import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "capabilities" }
const _hoisted_2 = { class: "group" }
const _hoisted_3 = { class: "group" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Badge = _resolveComponent("Badge")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title" }, "Skills", -1 /* HOISTED */)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.store.caps.skills, (skill) => {
        return (_openBlock(), _createBlock(_component_Checkbox, {
          key: skill.command,
          "model-value": $options.skills.includes(skill.command),
          onChange: $event => ($options.toggle('skills', skill.command))
        }, {
          default: _withCtx(() => [
            _createElementVNode("b", null, _toDisplayString(skill.command), 1 /* TEXT */),
            _createTextVNode(" - " + _toDisplayString(skill.title), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["model-value", "onChange"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "Sources", -1 /* HOISTED */)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.store.caps.sources, (source) => {
        return (_openBlock(), _createBlock(_component_Checkbox, {
          key: source.command,
          "model-value": $options.sources.includes(source.command),
          onChange: $event => ($options.toggle('sources', source.command))
        }, {
          default: _withCtx(() => [
            _createElementVNode("b", null, _toDisplayString(source.command), 1 /* TEXT */),
            _createTextVNode(" - " + _toDisplayString(source.title) + " ", 1 /* TEXT */),
            (source.file_count != null)
              ? (_openBlock(), _createBlock(_component_Badge, {
                  key: 0,
                  gray: "",
                  class: "file-count"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(source.file_count.toLocaleString()), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */))
              : _createCommentVNode("v-if", true)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["model-value", "onChange"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}